import React from 'react';
import { useNavigate } from 'react-router-dom';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { getGroupData } from '../../service/adminApi';
import './entitlement.css';

function UserManagement() {
    let breadCrumbsData = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'Admin', isActive: true, path: '/admin/accountbranding' },
        { title: 'User Management', isActive: true, path: '' },
        { title: 'Category', isActive: false, path: '' },
    ];

    const navigate = useNavigate();
    const [groupList, setGroupList] = React.useState([]);

    React.useEffect(() => {
        getGroups();
    }, []);

    const getGroups = async () => {
        const response = await getGroupData();

        setGroupList(response.data.data);
    };

    const handleNavigation = () => {
        navigate('/admin/CreateGroup');
    };

    const deleteGroup = (index) => { };

    const renderGroupList = () => {
        return groupList.map((group, index) => {
            return (
                <tr className="hive-table-data regular-text align-middle" key={index}>
                    <td>{group.name}</td>
                    <td>{group.description}</td>
                    <td>{group.userCount}</td>
                    <td>{group.group_status == 1 ? `Active` : `In Active`}</td>

                    {/* <td className="text-center">
                        <a
                            className=" ms-2"
                            alt=""
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRight"
                            aria-controls="offcanvasRight"
                        >
                            <img src="/Images/edit1.svg" className="ms-1" alt="bin" />
                        </a>
                        <a
                            onClick={() => {
                                deleteGroup(index);
                            }}
                            className=""
                            alt=""
                        >
                            <img src="/Images/bin.svg" className="ms-3" alt="close" />
                        </a>
                    </td> */}
                </tr>
            );
        });
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbsData} />
            <div className="row">
                <div className="col-md-12">
                    <div className="d-flex justify-content-between">
                        <h5 className="bold-text tt-bold font-18">Manage Groups</h5>
                        <button
                            className="btn hive-btn-primary"
                            disabled
                            onClick={() => {
                                handleNavigation();
                            }}
                        >
                            <img className="me-2" src="/Images/plus.svg" />
                            Create Group
                        </button>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="tab-content" id="pills-tabContent">
                        {/*All Leave Request Section Starts Here*/}
                        <div
                            className="tab-pane fade show active mt-4"
                            id="all_leave_request"
                            role="tabpanel"
                            aria-labelledby="all_leave_request_tab"
                        >
                            <div className="table-responsive rounded-3 mb-5 ">
                                <table className="table bg-white hive-grid table-borderless ">
                                    <thead className="hive-table-head ">
                                        <tr>
                                            <th className="bold-text font-12">Group Name</th>
                                            <th className="bold-text font-12">Description</th>
                                            <th className="bold-text font-12"># of users</th>
                                            <th className="bold-text font-12">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>{renderGroupList()}</tbody>
                                </table>
                            </div>
                        </div>
                        {/*My WFH Request Section Ends Here*/}
                    </div>
                    {/*Tab Content Ends Here*/}
                </div>
            </div>
        </div>
    );
}

export default UserManagement;
